import { Injectable } from '@angular/core'
import Swal from 'sweetalert2'
import * as XLSX from 'xlsx'
import * as FileSaver from 'file-saver'

@Injectable({
  providedIn: 'root',
})
export class HelperFunctions {
  /**
   * Capitalize word
   * @param string word
   */
  capitalize(word: string): string {
    if (typeof word !== 'string') return ''
    return `${word.charAt(0).toUpperCase()}${word.slice(1)}`
  }

  /**
   * Transform To Title Case.
   * @param str sentents
   */
  titleCase(str: string): string {
    return str
      .toLowerCase()
      .split(' ')
      .map((word) => {
        return `${word.charAt(0).toUpperCase()}${word.slice(1)}`
      })
      .join(' ')
  }

  /**
   * Display alerts
   */
  displayAlert(message: string, status) {
    const title = status.charAt(0).toUpperCase() + status.slice(1)
    Swal.fire(title, message, status)
  }

  /**
   * Export json data to excel file
   */
  exportToExcel(data: any[], fileName: string): void {
    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    const fileExtension = '.xlsx'

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data)
    const wb: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ['data'] }
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })

    const fileData: Blob = new Blob([excelBuffer], { type: fileType })
    FileSaver.saveAs(fileData, fileName + fileExtension)
  }
}
